import { useEffect, useState } from "react"

interface props {
  error: any,
  customClass?: string
}
export default function Error({ error, customClass }: props) {
  const [msg, setMsg] = useState<string | null>(null)
  useEffect(() => {
    if (error) {
      console.log("Error object:", error);
      // if (error.type) { setMsg(error.type) }
      // if (error.message) {
      //   console.log("error.option--------------", error.message)
      //   if (error.message !== '') {
      //     setMsg(error.message)
      //   } else {
      //     console.log("error.option--------------", error.option)
      //     if(error.option){
      //       setMsg(error.option.message)
      //     }
      //   }
      // }
      // Priority: message > option.message > meaningful type > fallback
      if (error.message && typeof error.message === 'string' && error.message.trim() !== '') {
        setMsg(error.message.trim())
      } else if (error.option && error.option.message && typeof error.option.message === 'string' && error.option.message.trim() !== '') {
        setMsg(error.option.message.trim())
      } else if (error.type && typeof error.type === 'string' && error.type.length > 3) {
        // Only use type if it's a meaningful message (more than 3 characters)
        setMsg(error.type)
      } else {
        // Map common React Hook Form validation types to user-friendly messages
        const errorTypeMap: { [key: string]: string } = {
          'required': 'This field is required',
          'pattern': 'Please enter a valid value',
          'minLength': 'Input is too short',
          'maxLength': 'Input is too long',
          'min': 'Value is too small',
          'max': 'Value is too large',
          'validate': 'Please enter a valid value'
        };
        
        if (error.type && errorTypeMap[error.type]) {
          setMsg(errorTypeMap[error.type]);
        } else {
          // Don't show error for single character or meaningless errors
          setMsg(null);
        }
      }
    } else {
      setMsg(null)
    }
  }, [error])

  return (
    <>
      {msg ? (
        <p className={`text-danger mt-2 ${customClass}`}>
          <span>{msg}</span>
        </p>
      ) : null}
    </>
  )

}